/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Mitch Wilson <mitchell.wilson@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const DASHBOARD_STAT_WITH_PREVIOUS_FRAGMENT = gql`
  fragment DashboardStatWithPrevious on DashboardStatWithPrevious {
    id
    name
    totalRevenue
    previousTotalRevenue
    emptyFacings
    previousEmptyFacings
    compliance
    previousCompliance
    restockCompletion
    previousRestockCompletion
    taskCompletion
    previousTaskCompletion
  }
`

export const DASHBOARD_STAT_FRAGMENT = gql`
  fragment DashboardStat on DashboardStat {
    id
    name
    totalRevenue
    emptyFacings
    compliance
    restockCompletion
    taskCompletion
  }
`
